// components/HeroSection.js
import React from "react";

function HeroSection() {
  return (
    <section className="bg-gray-100 py-16">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center justify-between">
          <div className="md:w-1/2 md:text-left mb-8 md:mb-0">
            <h1 className="text-4xl lg:text-5xl font-bold leading-tight mb-4 section-title">
              Work With The Top Marketers To <span className="text-shadow underline-span">Grow Your Business</span>
            </h1>
            <p className="text-lg text-gray-700 mb-6 section-subtitle">
              Top 1% marketing experts in your niche with proven ROI results, backed by unbiased monitoring.
            </p>
            <div className="flex justify-center md:justify-start space-x-4">
              <button className="bg-customcolor hover:bg-customcolor text-white font-bold py-3 px-6 text-lg transition duration-300 ease-in-out">
                Learn More
              </button>
            </div>
          </div>
          <div className="md:w-1/2 text-center">
            <img
              src="assets/images/home/Exponent-marketing-firm-hero-img-1.png"
              alt="Hero"
              className="rounded-lg shadow-lg mx-auto w-full h-auto max-w-md md:max-w-full"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
